<template>
  <div class="productcenterhtml">
    <div class="productcenterhead">
      <div class="productcenterheadtext">
        <p
          style="
            float: left;
            font-size: 18px;
            color: #275479;
            font-weight: bold;
            line-height: 30px;
            margin-left: 3px;
          "
        >
          收费行情数据
        </p>
      </div>
    </div>
    <div class="productcenterbody">
        <div class="white_box">
            <table class="table2">
                <tr><th align="center" >数据所属交易所/市场<sup>*1</sup></th><th style="width:300px;" align="center">价格（元/年/账号）</th></tr>
                <tr><td class="midtxt" style="width:360px;">芝加哥期货交易所（CBOT）</td><td class="price">+{{filterid(143,'price')}} / {{filterid(143,'majorprice')}}（专业用户）<span style="position:relative" ref="pop"><img src="../../assets/images/wenhgm.png"  class="imghuo"><Pop class="pop" v-show="showpop"></Pop></span></td></tr>
                <tr><td class="midtxt">芝加哥商品交易所（CME）</td><td class="price">+{{filterid(144,'price')}} / {{filterid(144,'majorprice')}}（专业用户）</td></tr>
              <tr><td class="midtxt">纽约商业交易所（NYMEX）</td><td class="price">+{{filterid(141,'price')}} / {{filterid(141,'majorprice')}}（专业用户）</td></tr>
              <tr><td class="midtxt">纽约商品交易所（COMEX）</td><td class="price">+{{filterid(142,'price')}} / {{filterid(142,'majorprice')}}（专业用户）</td></tr>
              <tr><td class="midtxt">欧洲期货交易所（EUREX）</td><td class="price">+{{filterid(291,'price')}}（个人）<sup>*2</sup></td></tr>
              <tr><td class="midtxt">伦敦金属交易所（LME）</td><td class="price">+{{filterid(286,'price')}}</td></tr>
              <tr><td class="midtxt">洲际交易所（ICE）- 美国</td><td class="price">+{{filterid(199,'price')}}</td></tr>
              <tr><td class="midtxt">洲际交易所（ICE）- 欧洲商品</td><td class="price">+{{filterid(200,'price')}}</td></tr>
              <tr><td class="midtxt">香港股票（仅境内查看）</td><td class="price">+{{filterid(336,'price')}}（个人） / {{filterid(336,'majorprice')}}（公司）</td></tr>
              <tr><td class="midtxt">香港股票（需境外查看）</td><td class="price">+{{filterid(340,'price')}}</td></tr>
              <tr><td class="midtxt">美国股票</td><td class="price">+{{filterid(84,'price')}}</td></tr>
              <tr><td class="midtxt">全球外汇</td><td class="price">+{{filterid(378,'price')}}</td></tr>
              <tr><td class="midtxt">伦敦金数据</td><td class="price">+{{filterid(83,'price')}}</td></tr>
              <tr><td class="midtxt">上海黄金交易所数据（黄金T+D等）	</td><td class="price">+{{filterid(170,'price')}}</td></tr>
              <tr><td class="midtxt">五档 - 大连商品交易所（DCE）</td><td class="price"><a class="wenhaogm" href="https://www.wenhua.com.cn/Home/ChargeDataDLEVEL2" target="_blank" style="border:none" >+{{filterid(79,'price')}}/+{{filterid(78,'price')}}（Level2）<img src="../../assets/images/wenhgm.png"  class="imghuo"></a></td></tr>
              <tr><td class="midtxt">五档 - 郑州商品交易所（ZCE）</td><td class="price">+{{filterid(81,'price')}}</td></tr>
              <tr><td class="midtxt">五档 - 上海黄金交易所数据(黄金T+D等)</td><td class="price">+{{filterid(348,'price')}}</td></tr>
              <tr><td class="midtxt">五档 - 芝加哥期货交易所（CBOT）</td><td class="price">+{{filterid(147,'price')}} / {{filterid(147,'majorprice')}}（专业用户）</td></tr>
              <tr><td class="midtxt">五档 - 芝加哥商品交易所（CME）</td><td class="price">+{{filterid(148,'price')}} / {{filterid(148,'majorprice')}}（专业用户）</td></tr>
              <tr><td class="midtxt">五档 - 纽约商业交易所（NYMEX）</td><td class="price">+{{filterid(145,'price')}} / {{filterid(145,'majorprice')}}（专业用户）</td></tr>
              <tr><td class="midtxt">五档 - 纽约商品交易所（COMEX）</td><td class="price">+{{filterid(146,'price')}} / {{filterid(146,'majorprice')}}（专业用户）</td></tr>
                <!-- <tr><td rowspan="5"   valign="middle" align="center" style="text-align:center;padding-left:5px;line-height:19px"><div>产业数据模块</div><div><router-link to="/proc/productcenter3/one" target="_blank" class="linkjieshao">查看介绍</router-link></div></td ><td class="midtxt"> 品种画像</td><td rowspan="5"  vertical-align="middle" valign="middle" align="center" class="price">+3600元</td></tr>
                <tr><td class="midtxt">供应端追踪</td></tr>
                <tr><td class="midtxt">需求端追踪</td></tr>
                <tr><td class="midtxt">现货</td></tr>
                <tr><td class="midtxt">资金面</td></tr> -->
                
            </table>
            <div class="tipsss">
                <p class="zhu">注&nbsp;:</p>
                <p class="zhushi">
                *1.以上是选配付费行情数据，是指是指在标配数据以外可选择增加的数据授权，选配行情数据需另外支付相应费用(单位：元/年/账号)；
                </p>
                <p class="zhushi" style="padding-bottom: 13px">
                *2.欧洲期货交易所570元/年/终端的价格只针对中国境内个人用户购买有效。
                </p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import  Pop from './components/Pop.vue'
import axios from 'axios'
export default {
  data() {
    return {
     showpop:false,
     showpop2:false,
     setTime:'',
     webMarketPrice:{
        price1:0,
        price2:0,
        sublist:[],
      },
    };
  },
  components: {Pop},
  methods:{
    setPrice(){
      axios.get('https://pay.wenhua.com.cn/api/Product/Detail?id=76').then((res) => {
          if (res.data.status) {
            this.webMarketPrice.price1 = res.data.data.price
            this.webMarketPrice.sublist = res.data.data.sublist
          } else {
            alert(res.data.message)
          }
        });
        axios.get('https://pay.wenhua.com.cn/api/Product/Detail?id=123').then((res) => {
          if (res.data.status) {
            this.webMarketPrice.price2 = res.data.data.price
            
          } else {
            alert(res.data.message)
          }
        });
    },
    filterid(id,str){
        return  !!this.webMarketPrice.sublist.filter((el)=>{
          return el.id == id
        })[0]?this.webMarketPrice.sublist.filter((el)=>{
          return el.id == id
        })[0][str]:''
    },
    showP(e){
      if(this.$refs.pop.contains(e.target)){
        clearTimeout(this.setTime)
        this.setTime=''
        this.showpop=true
      }
      else if(this.$refs.pop2.contains(e.target)){
        clearTimeout(this.setTime)
        this.setTime=''
        this.showpop2=true
      }
      else{
        if(!!this.setTime){
          return
        }
        this.setTime = setTimeout(()=>{this.showpop=false,this.showpop2=false},300)
      }
    }
  },
  created(){
  window.addEventListener('mousemove',this.showP)
  this.setPrice()
  },
  beforeRouteLeave(to, from, next)  {
    window.removeEventListener('mousemove',this.showP)
    next()
  }

};
</script>

<style scoped>
.pop {
  position: absolute;
  left: 20px;
  top: 0px;
}
.eeee {
  color: blue;
}
.eeee :visited {
  color: blue;
}
.productcenterhtml {
  background: url("../../assets/images/ts-bg_02.jpg") no-repeat top, #eef0ff;
  /* background-size: 100% 100%; */
  min-width: 1400px;
  width: 100%;
}
.productcenterhead {
  position: relative;
  height: 140px;
  width: 1000px;
  margin: 0 auto;
}
.productcenterheadtext {
  position: absolute;
  top: 105px;
  left: 3px;
}
.productcenterbody {
  width: 1000px;
  margin: 0 auto;
  position: relative;
}
.white_box{
    width: 100%;
    background: white;
    border-radius: 10px;
    padding-top: 30px;
}

.linkjieshao{
  text-decoration: underline;
  color: blue;
  border: none !important;
}
.table1 a{
  /* text-decoration: underline !important; */
  border-bottom: 1px solid #7d4c3d;
}
.table2 {
    /* width: 932px; */
    margin: 0 auto;
}
.table1 a:hover{
  color: blue;
  border-bottom: 1px solid blue;
}
.table2 a{
  /* text-decoration: underline !important; */
  border-bottom: 1px solid #7d4c3d;
}
.table2 a:hover{
  color: blue;
  border-bottom: 1px solid blue;
}

/* .table1 tr td:nth-child(2){
  text-align: justify;
} */
/* .table1 tr th:last-child,.table2 tr th:last-child{
  border:none;
} */
.table1 .midtxt{
  letter-spacing: 0;
}
a.wenhaogm {
    color: #7d4c3d;
    text-decoration: none;
}
a.wenhaogm:visited {
    color: #7d4c3d;
}
a.wenhaogm:hover {
  color: #7d4c3d !important;
}
.tipsss {
  width: 932px;
  margin: 0 auto;
}
.zhu {
  /* background: url("../../assets/images/zhu.png") no-repeat; */
  margin-top: 20px;
  color: #898989;
  /* padding-left: 7px; */
  height: 25px;
  line-height: 25px;
  font-size: 14px;
}
.zhushi {
  line-height: 24px;
  font-size: 14px;
  color: #898989;
  letter-spacing: 1px;
  /* text-indent: 1em; */
}
td {
  /* border: 0; */
  text-align: left;
  padding-left: 2px;
  color: #7d4c3d;
  padding-right: 5px;
  padding-left: 2px;
  height: 28px;
  line-height: 28px;
}
sup {
  font-size: 12px;
  position: relative;
  top: -7px;
}
th{
  padding:13px 10px;
  background:#193f63;
  line-height:19px;
  letter-spacing:1px;
  font-size:15px;
  vertical-align: middle;
  color: white;
  border: 1px solid #cdcdcd;
}
.table2 a{
  /* text-decoration: underline !important; */
  border-bottom: 1px solid #7d4c3d;
}
.table2 a:hover{
  color: blue;
  border-bottom: 1px solid blue;
}
/* .table2 tr th{
  border-right: 1px solid white;
} */
/* .table1 tr td:nth-child(2){
  text-align: justify;
} */
/* .table2 tr th:last-child{
  border:none;
} */
.midtxt {
  padding-left: 10px;
  letter-spacing: 0.5px;
}
.price {
  padding-left: 10px;
  letter-spacing: 0.1px;
}
</style>